import {Pipe, PipeTransform} from "@angular/core";

@Pipe({ name: 'isInstanceOfObject' })
export class IsInstanceOfObjectPipe implements PipeTransform {
  transform(obj) {
    return obj instanceof Object;
  }
}
